import React from "react";
import { useEffect, useState } from "react";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line, Bar } from "react-chartjs-2";
import { useProducerCodeStates } from "../../CarrierAgreementMgmt/ProducerCodeConfig/hooks/useProducerCodeStates";
import { setDatasets } from "react-chartjs-2/dist/utils";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default function ProducerCodeChart() {
  const { data: producerCodeState } = useProducerCodeStates();

  const prodCodeData = {
    labels: producerCodeState?.result
      ?.map((x) => x.states)
      .sort((a, b) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1)),
    datasets: [
      {
        label: "Active",
        data: producerCodeState?.result?.map((x) => x.active),
        backgroundColor: "#0078D7",
        borderColor: "#0078D7",
      },
      {
        label: "Inactive",
        data: producerCodeState?.result?.map((x) => x.inActive),
        backgroundColor: "#CD0082",
        borderColor: "#CD0082",
      },
    ],
  };
  const prodCodeOptions = {
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        align: "center",
        labels: {
          usePointStyle: true,
        },
      },
    },
    responsive: true,
    scales: {
      x: {
        ticks: {
          autoSkip: false,
        },
        grid: {
          display: true,
        },
      },
      y: {
        grid: { display: true },
      },
    },
  };
  return (
    <>
      <Line
        data={prodCodeData}
        options={{
          plugins: {
            legend: {
              display: true,
              position: "bottom",
              align: "center",
              labels: {
                usePointStyle: true,
              },
            },
          },
          responsive: true,
          scales: {
            x: {
              ticks: {
                autoSkip: false,
              },
              grid: {
                display: false,
              },
            },
            y: {
              grid: { display: false },
            },
          },
        }}
        height={150}
        width={420}
      />
    </>
  );
}
